export const CREATING_BOOKING = "CREATING_BOOKING";
export const UPDATING_BOOKING = "UPDATING_BOOKING";
export const BOOKING_CREATED = "BOOKING_CREATED";
export const BOOKING_UPDATED = "BOOKING_UPDATED";
export const ERROR_BOOKING_CREATE = "ERROR_BOOKING_CREATE";
export const ERROR_BOOKING_UPDATE = "ERROR_BOOKING_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
